import { render, staticRenderFns } from "./_Footer.vue?vue&type=template&id=a08b37bc&scoped=true&"
import script from "./_Footer.vue?vue&type=script&lang=js&"
export * from "./_Footer.vue?vue&type=script&lang=js&"
import style0 from "./_Footer.vue?vue&type=style&index=0&id=a08b37bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08b37bc",
  null
  
)

export default component.exports